import { useNewNotificationEffects } from "../../hooks/notifications/useNewNotificationEffects";
import useNotificationsWSS from "../../hooks/wss/useNotificationsWSS";

// Mounted once inside the router. Subscribes to the per-account notifications
// WebSocket channel and fires side effects (sound, toast, browser push) for
// new entries.
export default function NotificationEffects() {
  useNotificationsWSS();
  useNewNotificationEffects();
  return null;
}
